<template>
  <v-container fluid fill-height>
    <v-layout>
      <v-flex xs12 sm12 md12>
        <v-card class="rounded-lg">
          <v-toolbar color="#f8f9fb" elevation="0">
            <v-toolbar-title>{{ $t("faq.add.title") }}</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn class="primary" @click="$router.go(-1)">
              <v-icon left> mdi-chevron-double-left </v-icon>
              {{ $t("bills.add.buttons.back") }}
            </v-btn>
          </v-toolbar>
          <v-divider></v-divider>
          <v-card-text class="pa-5">
            <v-form>
              <v-row>
                <v-col cols="12" xs="12" sm="12" md="6">
                  <v-textarea
                    v-model="faq.question"
                    :label="$t('faq.headers.question')"
                    v-validate="'required'"
                    name="question"
                    rows="1"
                    auto-grow
                    :error="errors.first('question') != null || serverSideErrors.question != null"
                    :error-messages="errors.first('question') || serverSideErrors.question"
                  ></v-textarea>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" xs="12" sm="12" md="6">
                  <v-textarea
                    v-model="faq.answer"
                    :label="$t('faq.headers.answer')"
                    v-validate="'required'"
                    name="answer"
                    rows="2"
                    auto-grow
                    :error="errors.first('answer') != null || serverSideErrors.answer != null"
                    :error-messages="errors.first('answer') || serverSideErrors.answer"
                  ></v-textarea>
                </v-col>
              </v-row>

            </v-form>
          </v-card-text>
          <v-card-actions class="pb-5 pl-10">
            <v-btn
              color="#2c3345"
              dark
              class="px-8"
              @click="saveFaq"
              :loading="loading"
              tile
              elevation="0"
              >SAVE</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { mapMutations } from "vuex";

export default {
  data() {
    return {
      loading: false,
      serverSideErrors: {},
      faq: {
        question: "",
        answer: "",
      },
    };
  },

  methods: {
    ...mapMutations("alert", ["setAlert"]),

    saveFaq() {
      let _self = this;
      this.$validator.validateAll().then((result) => {
        if (result) {
          _self.loading = true;
          _self.$axios
            .post("superadmin/faqs", _self.faq)
            .then((response) => {
              _self.loading = false;
              _self.serverSideErrors = {};

              if (response.data.status) {
                this.setAlert({
                  showAlert: true,
                  message: response.data.message,
                  variant: "green accent-4",
                  timeout: 2000,
                });
                _self.$router.push("/superadmin/faqs");
              } else {
                if (response.data.errors) {
                  response.data.errors.forEach((err) => {
                    _self.serverSideErrors[err.field] = err.message;
                  });
                } else {
                  this.setAlert({
                    showAlert: true,
                    message: response.data.message,
                    variant: "red accent-3",
                    timeout: 2000,
                  });
                }
              }
            })
            .catch((error) => {
              _self.loading = false;
              console.error(error);
              this.setAlert({
                showAlert: true,
                message: "An error occurred while saving",
                variant: "red accent-3",
                timeout: 2000,
              });
            });
        }
      });
    },
  },
};
</script>

<style scoped>
</style>
